import {
    FACETED_PAGE_CLASSES,
    LISTING_CONTAINER_SELECTOR,
    OBSERVER_IDLE_MS,
} from './constants';

function getObserverRoot() {
    const isFacetedPage = FACETED_PAGE_CLASSES.some((cls) => document.body.classList.contains(cls));

    if (isFacetedPage) {
        return document.querySelector(LISTING_CONTAINER_SELECTOR) || document.body;
    }

    return document.body;
}

export function startObserver({
    storefrontApiToken,
    collectPriceContainersFromNode,
    processPriceContainers,
    hydratePageBuilderBadges,
}) {
    const root = getObserverRoot();
    let idleTimer = null;
    let rafId = null;
    let pendingContainers = [];
    let isObserving = false;

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                pendingContainers.push(...collectPriceContainersFromNode(node));
            });
        });

        if (pendingContainers.length > 0 && rafId === null) {
            rafId = requestAnimationFrame(flushPending);
        }

        resetIdleTimer();
    });

    function flushPending() {
        rafId = null;

        if (pendingContainers.length === 0) {
            return;
        }

        const batch = pendingContainers;
        pendingContainers = [];

        processPriceContainers(batch, storefrontApiToken);
        hydratePageBuilderBadges(storefrontApiToken);
    }

    function observe() {
        if (isObserving) {
            return;
        }

        observer.observe(root, { childList: true, subtree: true });
        isObserving = true;
    }

    function pause() {
        if (!isObserving) {
            return;
        }

        observer.disconnect();
        isObserving = false;
    }

    function resetIdleTimer() {
        if (idleTimer) {
            clearTimeout(idleTimer);
        }

        idleTimer = setTimeout(() => {
            pause();
        }, OBSERVER_IDLE_MS);
    }

    function onUserInteraction() {
        if (!isObserving) {
            observe();
            resetIdleTimer();
        }
    }

    observe();

    window.addEventListener('scroll', onUserInteraction, { passive: true });
    window.addEventListener('click', onUserInteraction, { passive: true });
}
